import React, { useEffect } from "react";
import Banner from "../components/experience/Banner";
import Intro from "../components/experience/Intro";
import Powers from "../components/experience/Powers";
import Execution from "../components/experience/Execution";
import Tools from "../components/experience/Tools";
import StayWith from "../components/experience/StayWith";
import Markets from "../components/experience/Markets";
import Security from "../components/experience/Security";
import TraderDesigned from "../components/experience/TraderDesigned";
import CTA from "../components/experience/CTA";

function Experience() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden pb-[80px] xl:pb-0">
      <Banner />
      <Intro />
      <Powers />
      <Execution />
      <Tools />
      <StayWith />
      <Markets />
      <Security />
      <TraderDesigned />
      <CTA />
    </div>
  );
}

export default Experience;
